import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const PendingApproval = () => {
  const { signOut } = useAuth();

  return (
    <Layout>
      <section className="flex min-h-[60vh] items-center justify-center py-20">
        <Card className="w-full max-w-md text-center">
          <CardHeader>
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
              <Clock className="h-8 w-8 text-amber-600" />
            </div>
            <CardTitle className="font-display text-2xl">Account Pending Approval</CardTitle>
            <CardDescription className="mt-2">
              Your account has been created successfully! An administrator will review and approve your account shortly. You'll be able to access all features once approved.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button variant="outline" className="rounded-full" onClick={signOut}>
              <LogOut className="mr-1 h-3.5 w-3.5" /> Sign Out
            </Button>
          </CardContent>
        </Card>
      </section>
    </Layout>
  );
};

export default PendingApproval;
